import { defaultTheme } from '../theming/data/defaultTheme'

export const composeTheme = (props) => {
  const isTheme = props.theme?.theme
  if (!isTheme) {
    return { theme: { ...props.theme, ...defaultTheme.theme } }
  }
  const theme = Object.entries(defaultTheme.theme).reduce((theme, object) => {
    const [key, value] = object
    const prop = { [key]: { ...value, ...props.theme?.theme[key] } }
    return { ...theme, ...prop }
  }, {})

  return { theme: { ...props.theme, ...theme } }
}
